module.exports = __webpack_public_path__ + "TextaNarrow-Bold-webfont.4f2fc662c6a683fbe574.svg";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Bold-webfont.svg
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Bold-webfont.svg
// module chunks = styles